/**
 * Icônes SVG inline en trait (style Heroicons outline) pour les boutons et tuiles de l'interface.
 * Couleur héritée via currentColor ; taille via className (défaut w-4 h-4).
 */
import { SVGProps } from 'react';

const base: SVGProps<SVGSVGElement> = {
  fill: 'none',
  viewBox: '0 0 24 24',
  strokeWidth: 1.8,
  stroke: 'currentColor',
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  className: 'w-4 h-4',
  'aria-hidden': true,
};

const icon = (d: string) => (p: SVGProps<SVGSVGElement>) => (
  <svg {...base} {...p}><path d={d} /></svg>
);

/** Compteur (cadran et aiguille). */
export const IconMeter = icon('M4 15a8 8 0 1 1 16 0M12 15l3.5-4.5M12 15h.01M6.5 15h-.01M17.5 15h-.01M3 19h18');
/** Tableau électrique (modules). */
export const IconPanel = icon('M4 5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5ZM4 10h16M9 10v10M15 10v10M8 7h2M14 7h2');
/** Zone / pièce (repère). */
export const IconZone = icon('M12 21s-6-5.33-6-10a6 6 0 1 1 12 0c0 4.67-6 10-6 10ZM12 13a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z');
/** Point électrique / prise. */
export const IconPlug = icon('M9 3v5M15 3v5M6 8h12v3a6 6 0 0 1-12 0V8ZM12 17v4');
export const IconBolt = icon('M13 2 4 14h7l-1 8 9-12h-7l1-8Z');
export const IconAlign = icon('M4 6h16M4 12h16M4 18h16');
export const IconRefresh = icon('M4 4v5h5M20 20v-5h-5M5.6 9A8 8 0 0 1 19 7.5M18.4 15A8 8 0 0 1 5 16.5');
export const IconTrash = icon('M4 7h16M10 11v6M14 11v6M6 7l1 12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-12M9 7V4h6v3');
export const IconPlus = icon('M12 5v14M5 12h14');
export const IconEye = icon('M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12ZM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z');
export const IconPencil = icon('M4 20h4l10.5-10.5a2.1 2.1 0 0 0-3-3L5 17v3ZM13.5 6.5l3 3');
export const IconSave = icon('M4 5a1 1 0 0 1 1-1h11l4 4v11a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5ZM8 4v5h7V4M8 20v-6h8v6');
export const IconTemplate = icon('M9 4h6a1 1 0 0 1 1 1v1H8V5a1 1 0 0 1 1-1ZM6 6h12a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1ZM9 12h6M9 16h4');
/** Rotation portrait / paysage (tablette). */
export const IconRotate = icon('M7 3h7a2 2 0 0 1 2 2v9M10 21H9a2 2 0 0 1-2-2V8M16 14l3 3-3 3M10 6 7 3 4 6');
export const IconSliders = icon('M4 6h10M18 6h2M4 12h4M12 12h8M4 18h12M20 18h0M14 4v4M8 10v4M16 16v4');
export const IconCheck = icon('M5 13l4 4L19 7');
export const IconAlertTriangle = icon('M12 3 2.5 20h19L12 3ZM12 10v4M12 17h.01');
export const IconChevronLeft = icon('M15 6l-6 6 6 6');
export const IconCircleCheck = icon('M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM8.5 12.5l2.5 2.5 4.5-5');
